import React from 'react';
import { ToothSurface } from '../../../../graphql/graphql';
import { ToothViewData } from './teethData';
import DENTToothSurface from './DENTToothSurface';

interface Props {
	surfaces?: ToothSurface[];
	color: string;
	patternId: string;
	toothViewData: ToothViewData;
}

const DENTToothWearSurfaces = ({
	surfaces,
	color,
	patternId,
	toothViewData,
}: Props) => {
	if (!surfaces?.length) {
		return <></>;
	}

	return (
		<>
			<defs>
				<pattern
					id={patternId}
					patternUnits='userSpaceOnUse'
					width='12'
					height='12'
					patternTransform='rotate(45)'>
					<rect width='6' height='12' fill={color} />
				</pattern>
			</defs>

			<g opacity='0.7'>
				{surfaces.map((surface, index) => (
					<DENTToothSurface
						key={index}
						toothViewData={toothViewData}
						surface={surface}
						patternId={patternId}
					/>
				))}
			</g>
		</>
	);
};

export default DENTToothWearSurfaces;
